export default __webpack_public_path__ + "assets/team-wide-scope.8a549cbf73.png";